import './thomaspreti/style';
import FormStructure from './thomaspreti/form_structure';

export default FormStructure;